import React,{useState, CSSProperties} from 'react';
import styled from 'styled-components';
import {CONSTS}  from './_constants';
import EmptyImage from './../../static/img/empty.svg'
import { Button, ComponentModesEnum } from '.';
import Link from './link';
type ButtonProps = {
    className?: string,
    style?: CSSProperties,
    width?: string | number,
    description?: string
}
const EmptyComponent = (props:ButtonProps) => {
    return (
         <div className={props.className}>
            <img src={EmptyImage} style={{marginLeft:'auto',marginRight:'auto'}}/>
            <div className="_desc">
               {props.description ? props.description : "موردی یافت نشد"}
            </div>
            <br/>
            {/* <Button mode={ComponentModesEnum.Primary}> */}
               <Link to="/" style={{color:CONSTS.colors.primary,fontWeight:500,fontSize:'.8rem'}}>
                  بازگشت به داشبورد
               </Link>
            {/* </Button> */}
         </div>
      )
    }

const Empty = styled(EmptyComponent)`
   display: flex;
   align-items: center;
   align-content: center;
   justify-content:center;
   flex-direction: column;
   margin-top: 10vh;
   width: 100%;
   img {
      width: ${props => props.width ? props.width : "25%"};
   }
   ._desc {
      margin-top: 40px;
      font-family: ${CONSTS.fonts.primary.bold};
      font-weight: 500;
      text-align: center;
      font-size: 1rem;
      color: ${CONSTS.colors.info};
   }
`;

export default Empty;